module.exports = {"title":"#STOP_E40","tagline":"Общественная кампания против строительства водного пути&nbsp;Е40, который угрожает ценным природным территориям Польши, Беларуси и&nbsp;Украины"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/content/hero-unit.ru.json
// module id = 165
// module chunks = 0